import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserControllerService } from 'src/app/services/user-controller.service';

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.scss']
})
export class InstructionsComponent implements OnInit {

  userData = {
    name: "",
    lastname: "",
    license: "0",
    username: "",
    status: true,
    profile_picture: ""
  };

  constructor(private _candidates: UserControllerService,
    private router: Router) { }

  ngOnInit(): void {

    this._candidates.getCandidate({}).subscribe(resolve => {
      this.userData = resolve[0]
      console.log(this.userData)
    })
  }

  nextPage() {
    this.router.navigate(['/cam'])
  }

}
